module.exports = __webpack_public_path__ + "img/Icon-Light.15ac6408.jpg";